<mat-card class="searchbox-card">
  <mat-card-header>
    <mat-card-title>
      <h2>{{ title }}</h2>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form class="search-form">
      <div *ngFor="let field of data; let i=index">
        <div [ngSwitch]="field.type">
          <mat-form-field [ngClass]="showSubCategory(formValues.tipologia, field)">
            <mat-label>{{ field.label }}</mat-label>
            <!-- text input -->
            <input *ngSwitchCase="'input'" matInput placeholder="{{field.placeholder}}"
                   value="{{field.value}}" [(ngModel)]="formValues.descrizione" name="descrizione">

            <input *ngSwitchCase="'input_nome'" matInput placeholder="{{field.placeholder}}"
                   value="{{field.value}}" [(ngModel)]="formValues.nomeUtente" name="nome">

            <input *ngSwitchCase="'input_cognome'" matInput placeholder="{{field.placeholder}}"
                   value="{{field.value}}" [(ngModel)]="formValues.cognomeUtente" name="cognome">

            <input *ngSwitchCase="'input_cf'" matInput placeholder="{{field.placeholder}}"
                   value="{{field.value}}" [(ngModel)]="formValues.codiceFiscale" name="cf">
            <!-- end text input -->
            <!-- select -->
            <mat-select *ngSwitchCase="'select'" [(ngModel)]="formValues.area" name="area">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'allegato_select'" [(ngModel)]="formValues.tipoAllegato" name="tipoAllegato">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'select_tipologia'" [(ngModel)]="formValues.tipologia"
                        name="tipologia">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'sottocategoria_comp_di_base'" [(ngModel)]="formValues.sottocategoriacompdibase"
                        name="sottocategoria_comp_di_base">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'select_sub'" [(ngModel)]="formValues.area" name="area_sub">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'select_stato_competenza'" [(ngModel)]="formValues.statoCompetenza"
                        name="stato_competenza">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'select_stato_conoscenza'" [(ngModel)]="formValues.stato"
                        name="stato_conoscenza">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'select_stato_proposta'" [(ngModel)]="formValues.statoProposta"
                        name="stato_proposta">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>

            <mat-select *ngSwitchCase="'select_stato_assemblea'" [(ngModel)]="formValues.statoAssemblea"
                        name="stato_assemblea">
              <mat-option *ngFor="let item of field.options" [value]="item">
                {{ item.descrizione }}
              </mat-option>
            </mat-select>
            <!-- end select -->
            <!-- datepicker -->

            <input *ngSwitchCase="'date1'" matInput [matDatepicker]="dp31" disabled name="datepicker1"
                   [(ngModel)]="formValues.dataRiunione" [max]="maxDateRiunione" (dateInput)="setMinApprovazione()">

            <mat-datepicker-toggle *ngSwitchCase="'date1'" matIconSuffix
                                   [for]="dp31"></mat-datepicker-toggle>
            <mat-datepicker #dp31 disabled="false"></mat-datepicker>
            <!-- end datepicker -->

            <!-- datepicker -->

            <input *ngSwitchCase="'date2'" matInput [matDatepicker]="dp32" disabled name="datepicker2"
                   [(ngModel)]="formValues.dataApprovazione" [min]="minDateApprovazione" (dateInput)="setMaxRiunione()">

            <mat-datepicker-toggle *ngSwitchCase="'date2'" matIconSuffix
                                   [for]="dp32"></mat-datepicker-toggle>
            <mat-datepicker #dp32 disabled="false"></mat-datepicker>
            <!-- end datepicker -->
          </mat-form-field>

        </div>
      </div>

      <button mat-fab extended class="searchbox-buttons ricerca-button" *ngIf="name!='creaAllegati'"
              [disabled]="(name == 'archivioAbilitaConoscenze' && !formValues.tipologia) || (name == 'caricaDocumenti' && !formValues.area)"
              (click)="loadContent(formValues)">
        <mat-icon>search</mat-icon>
        Ricerca
      </button>
      <button mat-fab extended class="searchbox-buttons ricerca-button" *ngIf="name=='creaAllegati'"
              [disabled]="(name == 'creaAllegati' && (!formValues.tipoAllegato || (formValues.tipoAllegato.id!=2 && formValues.tipoAllegato.id!=3)))"
              (click)="scaricaAllegato()">
        <mat-icon>download</mat-icon>
        Download
      </button>
      <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="reset()">
        <mat-icon>undo</mat-icon>
        Ripristina
      </button>
    </form>
  </mat-card-content>
</mat-card>
<div class="new-button-wrapper">


  <button mat-fab extended class="new-button" (click)="importaSedi()"
          *ngIf="!isAssistenza &&  (name == 'gestioneOperatori')">
    Importazione sedi
  </button>
  <button mat-fab extended class="new-button" (click)="importaOperatori()"
          *ngIf="!isAssistenza &&  (name == 'gestioneOperatori')">
    Importazione operatori
  </button>
  <button mat-fab extended class="new-button" (click)="newDetail('new_documento', formValues.area.id)"
          *ngIf="formValues.area &&  (name == 'caricaDocumenti')">
    Carica nuovo documento
  </button>
  <button mat-fab extended class="new-button" (click)="newDetail('new',undefined)" *ngIf="!isAssistenza && buttonText">
    <mat-icon>add</mat-icon>
    {{ buttonText }}
  </button>

</div>
